import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IAttributeRulesResponseBody, ICreateAttributeRuleRequestBody } from './types';

const GENERIC_ERROR_MESSAGE = 'Failure to create attribute rule. Please try again';

export const createAttributeRule = async (
  itemId: string,
  payload: ICreateAttributeRuleRequestBody,
  file: File | null,
): Promise<IAttributeRulesResponseBody> => {
  const requestBody = new FormData();
  requestBody.append('data', JSON.stringify(payload));
  if (file) {
    requestBody.append('files', file);
  }

  const res = await fetch(`${API_URL}/items/${itemId}/attribute-rules`, {
    method: 'POST',
    body: requestBody,
  }).catch(() => {
    throw new Error(GENERIC_ERROR_MESSAGE);
  });

  if (!res.ok) {
    const errorBody: { message?: string } | null = await res.json().catch(() => null);
    throw new Error(errorBody?.message || GENERIC_ERROR_MESSAGE);
  }

  return res.json();
};
